import store from '../store'

export default [
  {
    path: '/relatorios/industria',
    name: 'relatorios-industria-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getIndustrias')
      await store.commit('setRelatorio', [])
      next()
    },
    meta: {
      title: 'Relatórios de industrias',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria'
      )
    }
  },
  {
    path: '/relatorios/industria/contrato/ativo/exibir',
    name: 'relatorios-industria-contrato-ativo-show',
    beforeEnter: async (to, from, next) => {
      const { industria } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaContratoAtivo', {
        industria: Number(industria)
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: false,
      title: 'Relatório de contratos ativos',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/contrato/ativo'
      )
    }
  },
  {
    path: '/relatorios/industria/contrato/inativo/exibir',
    name: 'relatorios-industria-contrato-inativo-show',
    beforeEnter: async (to, from, next) => {
      const { industria } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaContratoInativo', {
        industria: Number(industria)
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: false,
      title: 'Relatório de contratos inativos',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/contrato/inativo'
      )
    }
  },
  {
    path: '/relatorios/industria/proteina/exibir',
    name: 'relatorios-industria-proteina-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaProteina', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de proteína (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/proteina'
      )
    }
  },
  {
    path: '/relatorios/industria/gordura/exibir',
    name: 'relatorios-industria-gordura-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaGordura', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de gordura (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/gordura'
      )
    }
  },
  {
    path: '/relatorios/industria/lactose/exibir',
    name: 'relatorios-industria-lactose-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaLactose', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de lactose (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/lactose'
      )
    }
  },
  {
    path: '/relatorios/industria/solido/exibir',
    name: 'relatorios-industria-solido-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaSolido', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de sólidos (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/solido'
      )
    }
  },
  {
    path: '/relatorios/industria/ccs-cpp/exibir',
    name: 'relatorios-industria-ccs-cpp-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaCCSWithCPP', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de CCS e CPP (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/ccsCpp'
      )
    }
  },
  {
    path: '/relatorios/industria/cpp/exibir',
    name: 'relatorios-industria-cpp-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaCPP', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de CPP (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/cpp'
      )
    }
  },
  {
    path: '/relatorios/industria/esd/exibir',
    name: 'relatorios-industria-esd-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaESD', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de ESD (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/esd'
      )
    }
  },
  {
    path: '/relatorios/industria/volume/exibir',
    name: 'relatorios-industria-volume-show',
    beforeEnter: async (to, from, next) => {
      const { industria, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustria', {
        id: Number(industria)
      })
      await store.dispatch('getRelatorioIndustriaVolume', {
        industria: Number(industria),
        inicial,
        final
      })
      next()
    },
    meta: {
      isIndustry: true,
      isChart: true,
      title: 'Relatório do índice de volume (por indústria)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/industria/filtros/volume'
      )
    }
  }
]
